import type ModuleButtonsType from '../../components/ModuleButtonsType';
import { showDeleteDialog, Utils } from 'app/main/components';
import { showAddNotesDialog } from 'app/main/submodules/notes/NotesAddDialog';
import { showFastAddDialog } from '../../components/FastAddDialog';

const buttons: ModuleButtonsType = {
	view: {
		itemButtons: [
			{
				name: 'VIEW_ITEM_BUTTON_EDIT',
				icon: 'edit',
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(showFastAddDialog({ module: model.marw_table, updateRefresh, isUpdate: true, model }))
			},
			// {
			// 	name: 'VIEW_ITEM_BUTTON_ADD_COPY',
			// 	icon: 'content-copy',
			// 	iconAdd: true,
			// 	action: ({ model, t }) => {
			// 		const { maac_title } = model;
			// 		Utils.openLink({
			// 			pathname: '/marketingactions/add',
			// 			state: {
			// 				model: { ...model, maac_title: maac_title + t('COPY') }
			// 			}
			// 		});
			// 	}
			// },
			{
				name: 'VIEW_ITEM_BUTTON_NEW_NOTE',
				icon: 'comment-text-multiple-outline',
				iconAdd: true,
				action: ({ model, dispatch }) =>
					dispatch(
						showAddNotesDialog({
							model: { note_table: model.marw_table, note_table_uid: model.peop_uid || model.comp_uid }
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_PERSON',
				icon: 'card-account-details-outline',
				iconAdd: true,
				hidden: ({ model }) => model.marw_table === 'people',
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'people',
							updateRefresh,
							model: {
								peop_maac_uid: model.marw_maac_uid,
								maac_title: model.maac_title,
								peop_comp_uid: model.comp_uid,
								comp_title: model.comp_title
							}
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_EVENT',
				icon: 'history',
				iconAdd: true,
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'chronology',
							updateRefresh,
							model: {
								chro_maac_uid: model.marw_maac_uid,
								maac_title: model.maac_title,
								chro_comp_uid: model.comp_uid,
								comp_title: model.comp_title,
								chro_peop_uid: model.peop_uid,
								peop_title: model.peop_title
							}
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_OPPORTUNITY',
				icon: 'thought-bubble-outline',
				iconAdd: true,
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'opportunities',
							updateRefresh,
							model: {
								oppo_maac_uid: model.marw_maac_uid,
								maac_title: model.maac_title,
								oppo_comp_uid: model.comp_uid,
								comp_title: model.comp_title,
								oppo_peop_uid: model.peop_uid,
								peop_title: model.peop_title
							}
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_ACTIVITY',
				icon: 'puzzle-outline',
				iconAdd: true,
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'activities',
							updateRefresh,
							model: {
								acti_maac_uid: model.marw_maac_uid,
								maac_title: model.maac_title,
								acti_comp_uid: model.comp_uid,
								comp_title: model.comp_title,
								acti_peop_uid: model.peop_uid,
								peop_title: model.peop_title
							}
						})
					)
			}
			// {
			// 	name: 'VIEW_ITEM_BUTTON_DELETE',
			// 	icon: 'delete',
			// 	action: ({ model, t, dispatch, updateRefresh }) =>
			// 		Utils.executeStored({
			// 			action: 'st_marketingactions_rows_delete',
			// 			dispatch,
			// 			data: {
			// 				marw_maac_uid: model.maac_uid,
			// 				values: [model.marw_uid]
			// 			},
			// 			successHandler: () => {
			// 				dispatch(Utils.alertSuccessMsg(t));
			// 				updateRefresh();
			// 			}
			// 		})
			// }
		]
	}
};

export default buttons;
